import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';

@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.css'],
})
export class FormPageComponent implements OnInit {
  companyForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.companyForm = this.fb.group({
      phoneNumber: ['', [Validators.required, this.phoneValidator()]],
      email: ['', [Validators.required, Validators.email]],
      companyName: [''],
      companyAddress: [''],
    });
  }

  submit(): void {
    if (this.companyForm.invalid) {
      return;
    }

    const formValue = this.companyForm.value;
    console.log('Form Submitted:', formValue);

    // TODO: send to API when ready
  }

  private phoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const phoneRegex = /^(?:\+234|234|0)[789]\d{9}$/;
      return phoneRegex.test(control.value)
        ? null
        : { invalidPhoneNumber: true };
    };
  }
}
